import React, { useState, useEffect } from 'react'
import { Item } from '../../../common/snippets'
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../common/dropDownOA'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../store/common/common_action'
import * as id from '../reportId'
import moment from 'moment'
import { focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import Datepicker from '../../../common/datePicker'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import { RenderTable } from '../analysisReport/summmaryTable'
import { globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { useAtom } from 'jotai'
import { RenderTableExcel } from '../analysisReport/summaryTableExcel'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import {columnDefsTwo, ColumnStyles1, ColumnStyles2, excelHeader, excelHeaderColumnTwo, tableDataTwo } from './constant'
import { crdeitDrawCellDetail } from '../../AcountingReport/common/AcountingConstants'
import { lrDetailPdfFooter } from '../onAccountCreditReport/const'


const PartyRechargeReport = (props) => {
  const {
    data: { common },
  } = props

  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [showTable, setShowTable] = useState(true)
  const { loginData} = common
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
  const [selPartyCity, setSelBranchCity] = useState({ id: 0, name: 'All' })
  const [selPartyName, setSelBranchName] = useState({ id: 0, name: 'All' })
  const [selRechargeMode, setSelRechargeMode] = useState({ id: 0, name: 'All' })
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }

  useEffect(() => {
    focusElemnt('fromDate')
  }, [])

  const handleLoad = () => {
    }

  const printClick = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const pdfColumns = columnDefsTwo.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = excelHeaderColumnTwo.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })

    const HeaderData = [
      {
        fromDate: moment(fromDate).format('DD-MMM-YYYY'),
        toDate: moment(toDate).format('DD-MMM-YYYY'),
        partyCity: selPartyCity?.name,
        partyName: selPartyName?.name,
        rechargeMode: selRechargeMode?.name,
      },
    ]

    const doc = new jsPDF({ orientation: 'P', format: [1080, 1528], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Party Recharge Reports.pdf`,
      subject: 'Party Recharge Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: ColumnStyles1,
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: tableDataTwo,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      columnStyles: ColumnStyles2,
      theme: 'grid',
      didParseCell: (data) => {
        crdeitDrawCellDetail(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Party Recharge Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        lrDetailPdfFooter(data, loginData, totalPagesExp)
      },
      // showHead: 'never',
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Party Recharge Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('PartyRechargeReport').data = pdfUrl
        // document.getElementById('PartyRechargeReport').data = doc.output('datauristring', ' Party Recharge Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('PartyRechargeReport').data = pdfUrl
        // document.getElementById('PartyRechargeReport').data = doc.output('datauristring', ' Party Recharge Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    }
  }

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: '10px', padding: '0 24px' }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }} className="itemButtons">
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              id={id.selectCompnay}
              label={'Company Name'}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              onSelect={(val) => {
                setShowTable(false)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: '140px' }} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={'From Recharge Date'}
              id={'fromRechargeDate'}
              dateChange={(date) => {
                setFromDate(date)
                setShowTable(false)
                focusElemnt('toRechargeDate')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: '140px' }} className="input--container bookingDatePicker">
            <Datepicker
              id={'toRechargeDate'}
              label={'To Recharge Date'}
              value={toDate}
              dateChange={(date) => {
                setToDate(date)
                setShowTable(false)
                focusElemnt('partyCity')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'partyCity'}
              label={'Party City'}
              //   data={bookingType}
              defaultvalue={selPartyCity?.name}
              idKey={`id`}
              dataKey={`name`}
              minWidth="200px"
              nextId={'partyName'}
              prevId={`toRechargeDate`}
              onSelect={(val) => {
                setSelBranchCity(val)
              }}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }}>
            <DropDownOA
              id={'partyName'}
              label={'Party Name'}
              //   data={chargeType}
              idKey={`id`}
              dataKey={`name`}
              defaultvalue={selPartyName?.name}
              minWidth="200px"
              nextId={'reachargeMode'}
              prevId={`partyCity`}
              onSelect={(val) => {
                setSelBranchName(val)
              }}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }}>
            <DropDownOA
              id={'reachargeMode'}
              label={'Recharge Mode'}
              //   data={chargeType}
              idKey={`id`}
              dataKey={`name`}
              defaultvalue={selRechargeMode?.name}
              minWidth="200px"
              nextId={'load_btn'}
              prevId={`partyName`}
              onSelect={(val) => {
                setSelRechargeMode(val)
              }}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
            <Button
              variant="contained"
              id={'load_btn'}
              sx={{ paddingY: '7px !important', height: '37px' }}
              className="btn btn-primary"
              onClick={handleLoad}
              onKeyDown={(e) => navigation3(e, 'pint_btn', 'reachargeMode', () => {})}
            >
              Load
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
            <Button
              variant="contained"
              id={'pint_btn'}
              sx={{ paddingY: '7px !important', height: '37px' }}
              className="btn btn-primary"
              onClick={() => printClick(false)}
              onKeyDown={(e) => navigation3(e, 'excel_btn', 'load_btn', () => {})}
            >
              Print
            </Button>
          </Item>
          <Box onKeyDown={(e) => navigation3(e, 'fromRechargeDate', 'pint_btn', () => {})}>
            <ReactHtmlTableToExcel
              id="branchRechExpToExlbtn"
              sx={{ paddingY: '7px !important', height: '37px' }}
              className="btn btn-primary"
              table="table-anPaymentWiseSummaryReport-xls"
              filename={`Party Recharge Report ${currentDateTime}`}
              sheet="tablexls"
              buttonText="Excel"
            />
          </Box>
        </Box>
      </Box>

      {showTable ? (
        <Box sx={{ marginTop: '15px', padding: '0 24px' }}>
          <RenderTable header={columnDefsTwo} data={tableDataTwo} key1={'fdierm'} key2={'sdiew'} key3={'orwex3'} />
          <Table id="table-anPaymentWiseSummaryReport-xls" size="small" aria-label="a dense table" style={{ display: 'none' }}>
            <TableHead style={{ fontWeight: 'bold' }}>
              <TableRow>
                <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={7}>
                  <h3 style={{ paddingLeft: '17px' }}>Report For: Party Recharge Report</h3>
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={6}>
                  <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData?.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={13}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                {excelHeader?.map((item, i) => (
                  <TableCell
                    className="ReportItemHead"
                    style={{ backgroundColor: '#e5f3ff', color: '#444444', fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                    colSpan={item.col}
                    key={i}
                  >
                    {item.value}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={2}>
                  {moment(fromDate).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={2}>
                  {moment(toDate).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={3}>
                  {selPartyCity?.name}
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={3}>
                  {selPartyName?.name}
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={3}>
                  {selRechargeMode?.name}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={13}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <>
                <RenderTableExcel header={columnDefsTwo} data={tableDataTwo} key1={'dskr1q'} key2={'sdi3m'} key3={'40dks3'} />
                <TableRow>
                  <TableCell colSpan={13}></TableCell>
                </TableRow>
              </>
            </TableBody>
          </Table>
        </Box>
      ) : (
        <>
          <Box style={{ width: '100%', paddingRight: '20px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              id="backBtn"
              sx={{ paddingY: '7px !important', height: '37px' }}
              className="btn btn-primary"
              onClick={() => {
                setShowTable(true)
              }}
              onKeyDown={(e) =>
                navigation3(e, id.fromDate, id.reportmainButton, () => {
                  setShowTable(true)
                })
              }
            >
              Back
            </Button>
          </Box>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="PartyRechargeReport"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - Party Recharge"
              aria-label="MTLPL -Cargo System -Party Recharge"
              style={{ marginTop: '10px' }}
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(PartyRechargeReport)
